import React from "react";
import { LinkBankFooter } from "../../linkbank/components";

const LinkBankFooterV2 = () => {

  return (
    <>
      <p className="mb-4">
        <a
          href="/application-troubleshooting"
          rel="noopener noreferrer"
          target="_blank"
          className="underline hover:text-green-primary"
        >
          Trouble connecting your account?
        </a>
      </p>
      <LinkBankFooter />
    </>
  );
};

export default LinkBankFooterV2;